import _toConsumableArray from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
export function SET_ARRAY(state, payload) {
  state[payload.module][payload.state] = _toConsumableArray(payload.data);
}
export function PUSH_ARRAY(state, payload) {
  state[payload.module][payload.state] = [].concat(_toConsumableArray(state[payload.state]), _toConsumableArray(payload.data));
}